export default {
      id: "marker-head-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#marker-head",
      toString: function () {
        return this.url;
      }
    }